import { useEffect } from "react";
import {
  initMixpanel,
  trackEvent,
  identifyUser,
  resetUser,
} from "@/lib/mixpanel";

/**
 * Hook to initialize Mixpanel with autocapture.
 * Should be used once at the root of your application.
 *
 * Autocapture automatically tracks:
 * - Page views
 * - Button/link clicks
 * - Form submissions
 * - Input changes
 */
export function useAnalyticsInit() {
  useEffect(() => {
    initMixpanel();
  }, []);
}

/**
 * Hook providing analytics functions for custom events
 * not covered by autocapture (e.g., business-specific events).
 */
export function useAnalytics() {
  return {
    /**
     * Track a custom event (for events not covered by autocapture)
     */
    track: trackEvent,

    /**
     * Identify a user (call when user signs up or logs in)
     */
    identify: identifyUser,

    /**
     * Reset/logout the current user
     */
    reset: resetUser,
  };
}
